import axios from "axios";
import * as Actions from "../actions/index"
 
const initialState = {
    //data
    // baseURL: "https://beta.myhomept.co"
     baseURL: "https://www.myhomept.co"    

};

export const UtilsReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case Actions.GETTING_URL:
            return {
                ...state,
                baseURL: payload
            }

        default:
            return state;
    }
}

